export default class BlockProfiles {
	constructor() {
		// Swiper n'est chargé que si la meta has_swiper_block est posée (cf. acf-fields.php) :
		// on sort proprement sinon, pour ne pas stopper l'init des autres composants.
		if (typeof Swiper === 'undefined') {
			return;
		}
		const blocks = document.querySelectorAll('.block-profiles');

		blocks.forEach((block) => {
			const swiper = block.querySelector('.swiper');
			if (!swiper) {
				return;
			}
			const prev = block.querySelector('.navigation-button-prev');
			const next = block.querySelector('.navigation-button-next');

			new Swiper(swiper, {
				slidesPerView: 1.15,
				spaceBetween: 24,
				grabCursor: true,
				breakpoints: {
					768: {
						slidesPerView: 1.1,
						spaceBetween: 60,
					},
					992: {
						slidesPerView: 1.5,
						spaceBetween: 80,
					},
				},
				navigation: {
					prevEl: prev,
					nextEl: next,
				},
			});
		});
	}
}
